import { restApiService } from '../../services/services';
import { handleAxiosResponse } from '../../util/apiHelpers';
import { axiosStorableError } from '../../util/errors';

// ================ Action types ================ //

const HANDLE_HOSTED_PAGE_REQUEST = 'app/SubscribeResponsePage/HANDLE_HOSTED_PAGE_REQUEST';
const HANDLE_HOSTED_PAGE_SUCCESS = 'app/SubscribeResponsePage/HANDLE_HOSTED_PAGE_SUCCESS';
const HANDLE_HOSTED_PAGE_ERROR = 'app/SubscribeResponsePage/HANDLE_HOSTED_PAGE_ERROR';

const RESET_STATE = 'app/SubscribeResponsePage/RESET_STATE';

const initialState = {
  handleHostedPageInProgress: false,
  handleHostedPageError: null,
  statusText: '',
};

export default function subscribeResponsePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case RESET_STATE:
      return initialState;

    case HANDLE_HOSTED_PAGE_REQUEST:
      return {
        handleHostedPageInProgress: true,
        handleHostedPageError: null,
        statusText: '',
      };

    case HANDLE_HOSTED_PAGE_SUCCESS:
      return {
        handleHostedPageInProgress: false,
        statusText: payload,
      };

    case HANDLE_HOSTED_PAGE_ERROR:
      return {
        handleHostedPageInProgress: false,
        handleHostedPageError: payload,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const resetStateAction = () => ({
  type: RESET_STATE,
});

const handleHostedPageRequest = () => ({
  type: HANDLE_HOSTED_PAGE_REQUEST,
});

const handleHostedPageSuccess = statusText => ({
  type: HANDLE_HOSTED_PAGE_SUCCESS,
  payload: statusText,
});

const handleHostedPageError = error => ({
  type: HANDLE_HOSTED_PAGE_ERROR,
  payload: error,
});

// ================ Selectors ================ //

export const $handleHostedPageState = state => {
  const subState = state.SubscribeResponsePage;
  return {
    inProgress: subState.handleHostedPageInProgress,
    error: subState.handleHostedPageError,
    data: subState.statusText,
  };
};

// ================ Thunks ================ //

export const resetState = () => dispatch => {
  dispatch(resetStateAction());
};

export const handleHostedPage = hostedPageId => dispatch => {
  dispatch(handleHostedPageRequest());
  return restApiService.secureInstance
    .postRaw('plans/handle-hosted-page', {
      hp_id: hostedPageId,
    })
    .then(handleAxiosResponse)
    .then(resp => {
      dispatch(handleHostedPageSuccess(resp));
      return resp;
    })
    .catch(e => {
      dispatch(handleHostedPageError(axiosStorableError(e)));
      throw e;
    })
  ;
};
